<template>
  <div class="gw">
    <div class="gwTitle">查询条件</div>
    <div class="xx">
      <div class="xxTitle">街镇</div>
      <el-select
        v-model="townCode"
        filterable
        remote
        reserve-keyword
        placeholder="请选择街道"
        @change="changeArea"
      >
        <el-option
          v-for="item in areaList"
          :key="item.dictValue"
          :label="item.dictName"
          :value="item.dictValue"
        >
        </el-option>
      </el-select>
    </div>
    <div class="xx">
      <div class="xxTitle">道路</div>
      <el-select
        v-model="roadId"
        filterable
        remote
        reserve-keyword
        placeholder="请选择"
        @change="changeRoad"
      >
        <el-option
          v-for="item in roadList"
          :key="item.id"
          :label="item.roadName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import ProjectApplyApi from "@/api/projectApply";
import CommonApi from "@/api/common";

export default {
  data() {
    return {
      townCode: "",
      roadId: "",
      roadList: [],
      areaList: [],
    };
  },
  mounted() {
    ProjectApplyApi.getDictList({
      dictCode: "town_code",
    }).then((res) => {
      if (res.data.code === 200) {
        this.areaList = res.data.data;
      }
    });
  },
  methods: {
    changeArea() {
      this.roadList = [];
      this.roadId = "";
      this.getRoadList();
    },
    changeRoad() {
      this.getGw();
    },
    getRoadList() {
      CommonApi.queryRoadList({
        roadName: "",
        townCode: this.townCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;
        } else {
          this.roadList = [];
        }
      });
    },
    getGw() {
      this.$emit("getGw", { townCode: this.townCode, roadId: this.roadId });
    },
  },
};
</script>

<style lang="scss" scoped>
.gw {
  .gwTitle {
    font-size: 20px;
    height: 30px;
    line-height: 30px;
    font-weight: 600;
  }
  .xx {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .xxTitle {
      margin-right: 20px;
      width: 40px;
    }
  }
}
</style>
